import { render } from "./Dropdown4.vue?vue&type=template&id=a8b5288e"
import script from "./Dropdown4.vue?vue&type=script&lang=ts"
export * from "./Dropdown4.vue?vue&type=script&lang=ts"
script.render = render

export default script